module.exports = __webpack_public_path__ + "static/media/tnt.9a1617ac.svg";